import ApiService from "@/core/services/api.service";
import querystring from "querystring";
import { responseError } from '@/core/mixin/shared'

const BASE = "dashboard";

export const MODULE_NAME = `dashboardModule`;
export const BASE_URL = `api/institutions`;
export const INSTITUTIONS_URL = `api/dashboard/institutions`;
export const INSTITUTIONS_BRANCHES_URL = `api/dashboard/institutions-branches`;
export const BRANCHES_URL = `api/dashboard/branches`;
export const SERVICES_URL = `api/dashboard/services`;
export const SERVICE_TYPE_URL = `api/dashboard/service-type`;
export const HISTORY_INSTITUTIONS_URL = `api/dashboard/all-institution`;
export const HISTORY_INSTITUTIONS_DATA_URL = `api/dashboard/institutions-history`;
export const MAP_INSTITUTIONS_URL = `api/dashboard/institutions-map`;
export const MAP_INSTITUTIONS_BRANCH_URL = `api/dashboard/institutions-branch-map`;
export const USER_ROLES_URL = `api/dashboard/user-roles`;
export const USER_HISTORIES_URL = `api/dashboard/users-histories`;
export const BRANCH_DATA_URL = `api/dashboard/branches-data`;


export const SERVICE_TYPE_LOADING = `${BASE}/SERVICE_TYPE_LOADING`;
export const SERVICE_STATUS_LOADING = `${BASE}/SERVICE_STATUS_LOADING`;
export const INSTITUTIONS_HISTORY_LOADING = `${BASE}/INSTITUTIONS_HISTORY_LOADING`;
export const INSTITUTIONS_LOADING = `${BASE}/INSTITUTIONS_LOADING`;
export const INSTITUTIONS_BRANCHES_LOADING = `${BASE}/INSTITUTIONS_BRANCHES_LOADING`;
export const MAP_INSTITUTIONS_LOADING = `${BASE}/MAP_INSTITUTIONS_LOADING`;
export const MAP_INSTITUTIONS_BRANCH_LOADING = `${BASE}/MAP_INSTITUTIONS_BRANCH_LOADING`;
export const USER_ROLES_LOADING = `${BASE}/USER_ROLES_LOADING`;
export const USER_HISTORIES_LOADING = `${BASE}/USER_HISTORIES_LOADING`;
export const BRANCH_DATA_LOADING = `${BASE}/BRANCH_DATA_LOADING`;


export const ERROR = `${BASE}/ERROR`;
export const SUCCESS = `${BASE}/SUCCESS`;
export const INSTITUTIONS = `${BASE}/INSTITUTIONS`;
export const BRANCHES = `${BASE}/BRANCHES`;
export const SERVICES = `${BASE}/SERVICES`;
export const SERVICE_TYPE = `${BASE}/SERVICE_TYPE`;
export const HISTORY_INSTITUTIONS = `${BASE}/HISTORY_INSTITUTIONS`;
export const HISTORY_INSTITUTIONS_DATA = `${BASE}/HISTORY_INSTITUTIONS_DATA`;
export const INSTITUTIONS_BRANCHES = `${BASE}/INSTITUTIONS_BRANCHES`;
export const MAP_INSTITUTIONS = `${BASE}/MAP_INSTITUTIONS`;
export const MAP_INSTITUTIONS_BRANCH = `${BASE}/MAP_INSTITUTIONS_BRANCH`;
export const USER_ROLES = `${BASE}/USER_ROLES`;
export const USER_HISTORIES = `${BASE}/USER_HISTORIES`;
export const BRANCHES_DATA = `${BASE}/BRANCHES_DATA`;


export const SET_SERVICE_TYPE_LOADING = `${BASE}/M/SET_SERVICE_TYPE_LOADING`;
export const SET_SERVICE_STATUS_LOADING = `${BASE}/M/SET_SERVICE_STATUS_LOADING`;
export const SET_INSTITUTIONS_HISTORY_LOADING = `${BASE}/M/SET_INSTITUTIONS_HISTORY_LOADING`;
export const SET_INSTITUTIONS_HISTORY_DATA_LOADING = `${BASE}/M/SET_INSTITUTIONS_HISTORY_DATA_LOADING`;
export const SET_INSTITUTION_LOADING = `${BASE}/M/SET_INSTITUTION_LOADING`;
export const SET_INSTITUTIONS_BRANCHES_LOADING = `${BASE}/SET_INSTITUTIONS_BRANCHES_LOADING`;
export const SET_MAP_INSTITUTIONS_LOADING = `${BASE}/SET_MAP_INSTITUTIONS_LOADING`;
export const SET_MAP_INSTITUTIONS_BRANCH_LOADING = `${BASE}/SET_MAP_INSTITUTIONS_BRANCH_LOADING`;
export const SET_USER_ROLES_LOADING = `${BASE}/SET_USER_ROLES_LOADING`;
export const SET_USER_HISTORIES_LOADING = `${BASE}/SET_USER_HISTORIES_LOADING`;
export const SET_BRANCHES_DATA_LOADING = `${BASE}/M/SET_BRANCHES_DATA_LOADING`;






export const SET_ERROR = `${BASE}/M/ERROR`;
export const SET_SUCCESS = `${BASE}/M/SUCCESS`;
export const SET_INSTITUTIONS = `${BASE}/M/INSTITUTIONS`;
export const SET_BRANCHES = `${BASE}/M/BRANCHES`;
export const SET_SERVICES = `${BASE}/M/SERVICES`;
export const SET_SERVICE_TYPE = `${BASE}/M/SERVICE_TYPE`;
export const SET_HISTORY_INSTITUTIONS = `${BASE}/M/SET_HISTORY_INSTITUTIONS`;
export const SET_HISTORY_INSTITUTIONS_DATA = `${BASE}/M/SET_HISTORY_INSTITUTIONS_DATA`;
export const SET_INSTITUTIONS_BRANCHES = `${BASE}/M/SET_INSTITUTIONS_BRANCHES`;
export const SET_MAP_INSTITUTIONS = `${BASE}/M/SET_MAP_INSTITUTIONS`;
export const SET_MAP_INSTITUTIONS_BRANCH = `${BASE}/M/SET_MAP_INSTITUTIONS_BRANCH`;
export const SET_USER_ROLES = `${BASE}/M/SET_USER_ROLES`;
export const SET_USER_HISTORIES = `${BASE}/M/SET_USER_HISTORIES`;
export const SET_BRANCHES_DATA = `${BASE}/M/SET_BRANCHES_DATA`;

export const RESET_VALUES = `${BASE}/M/RESET_VALUES`;

// ACTIONS

export const GET_SERVICE_TYPE_LOADING = `${BASE}/M/GET_SERVICE_TYPE_LOADING`;
export const GET_SERVICE_STATUS_LOADING = `${BASE}/M/GET_SERVICE_STATUS_LOADING`;
export const GET_INSTITUTIONS_HISTORY_LOADING = `${BASE}/M/GET_INSTITUTIONS_HISTORY_LOADING`;
export const GET_INSTITUTIONS_HISTORY_DATA_LOADING = `${BASE}/M/GET_INSTITUTIONS_HISTORY_DATA_LOADING`;
export const GET_INSTITUTION_LOADING = `${BASE}/M/GET_INSTITUTION_LOADING`;
export const GET_INSTITUTIONS_BRANCHES_LOADING = `${BASE}/M/GET_INSTITUTIONS_BRANCHES_LOADING`;
export const GET_MAP_INSTITUTIONS_LOADING = `${BASE}/M/GET_MAP_INSTITUTIONS_LOADING`;
export const GET_MAP_INSTITUTIONS_BRANCH_LOADING = `${BASE}/M/GET_MAP_INSTITUTIONS_BRANCH_LOADING`;
export const GET_USER_ROLES_LOADING = `${BASE}/M/GET_USER_ROLES_LOADING`;
export const GET_USER_HISTORIES_LOADING = `${BASE}/M/GET_USER_HISTORIES_LOADING`;
export const GET_BRANCHES_DATA_LOADING = `${BASE}/M/GET_BRANCHES_DATA_LOADING`;



export const GET_INSTITUTIONS = `${BASE}/GET_INSTITUTIONS`;
export const GET_BRANCHES = `${BASE}/GET_BRANCHES`;
export const GET_SERVICES = `${BASE}/GET_SERVICES`;
export const GET_SERVICE_TYPE = `${BASE}/GET_SERVICE_TYPE`;
export const GET_HISTORY_INSTITUTIONS = `${BASE}/GET_HISTORY_INSTITUTIONS`;
export const GET_HISTORY_INSTITUTIONS_DATA = `${BASE}/GET_HISTORY_INSTITUTIONS_DATA`;
export const GET_INSTITUTIONS_BRANCHES = `${BASE}/GET_INSTITUTIONS_BRANCHES`;
export const GET_MAP_INSTITUTIONS = `${BASE}/GET_MAP_INSTITUTIONS`;
export const GET_MAP_INSTITUTIONS_BRANCH = `${BASE}/GET_MAP_INSTITUTIONS_BRANCH`;
export const GET_USER_ROLES = `${BASE}/GET_USER_ROLES`;
export const GET_USER_HISTORIES = `${BASE}/GET_USER_HISTORIES`;
export const GET_BRANCHES_DATA = `${BASE}/M/GET_BRANCHES_DATA`;


const state = {
    items: null,
    institutions: null,
    historyInstitutions: null,
    historyInstitutionsData: null,
    institutionsBranches: null,
    mapInstitutions: null,
    mapInstitutionsBranch: null,
    userHistories: null,
    userRoles: null,
    serviceType: null,
    branches: null,
    services: null,
    error: null,
    success: null,
    branchesData: null,
    serviceTypeLoading: false,
    serviceStatusLoading: false,
    serviceInstitutionsLoading: false,
    institutionLoading: false,
    institutionHistoryDataLoading: false,
    institutionsBranchesLoading: false,
    mapInstitutionsLoading: false,
    mapInstitutionsBranchLoading: false,
    userRolesLoading: false,
    userHistoriesLoading: false,
    branchesDataLoading: false,
};

const getters = {
    [GET_SERVICE_TYPE_LOADING]: state => {
        return state.serviceTypeLoading;
    },
    [GET_SERVICE_STATUS_LOADING]: state => {
        return state.serviceStatusLoading;
    },
    [GET_INSTITUTIONS_HISTORY_LOADING]: state => {
        return state.serviceInstitutionsLoading;
    },
    [GET_INSTITUTIONS_BRANCHES_LOADING]: state => {
        return state.institutionsBranchesLoading;
    },
    [GET_INSTITUTIONS_HISTORY_DATA_LOADING]: state => {
        return state.institutionHistoryDataLoading;
    },
    [GET_INSTITUTION_LOADING]: state => {
        return state.institutionLoading;
    },
    [GET_MAP_INSTITUTIONS_LOADING]: state => {
        return state.mapInstitutionsLoading;
    },
    [GET_MAP_INSTITUTIONS_BRANCH_LOADING]: state => {
        return state.mapInstitutionsBranchLoading;
    },
    [GET_USER_HISTORIES_LOADING]: state => {
        return state.userHistoriesLoading;
    },
    [GET_USER_ROLES_LOADING]: state => {
        return state.userRolesLoading;
    },
    [GET_BRANCHES_DATA_LOADING]: state => {
        return state.branchesDataLoading;
    },
    [ERROR]: state => {
        return state.error;
    },
    [SUCCESS]: state => {
        return state.success;
    },
    [INSTITUTIONS]: state => {
        return state.institutions;
    },
    [GET_INSTITUTIONS]: state => {
        return state.historyInstitutions;
    },
    [BRANCHES]: state => {
        return state.branches;
    },
    [SERVICES]: state => {
        return state.services;
    },
    [HISTORY_INSTITUTIONS]: state => {
        return state.historyInstitutions;
    },
    [HISTORY_INSTITUTIONS_DATA]: state => {
        return state.historyInstitutionsData;
    },
    [SERVICE_TYPE]: state => {
        return state.serviceType;
    },
    [INSTITUTIONS_BRANCHES]: state => {
        return state.institutionsBranches;
    },
    [MAP_INSTITUTIONS]: state => {
        return state.mapInstitutions;
    },
    [MAP_INSTITUTIONS_BRANCH]: state => {
        return state.mapInstitutionsBranch;
    },
    [USER_HISTORIES]: state => {
        return state.userHistories;
    },
    [USER_ROLES]: state => {
        return state.userRoles;
    },
    [BRANCHES_DATA]: state => {
        return state.branchesData;
    }
};

const mutations = {
    [SET_ERROR]: (state, payload) => {
        state.error = responseError(payload);
    },
    [SET_SUCCESS]: (state, payload) => {
        state.success = payload;
    },
    [SET_SERVICE_TYPE_LOADING]: (state, payload) => {
        state.serviceTypeLoading = payload;
    },
    [SET_SERVICE_STATUS_LOADING]: (state, payload) => {
        state.serviceStatusLoading = payload;
    },
    [SET_INSTITUTIONS_HISTORY_LOADING]: (state, payload) => {
        state.serviceInstitutionsLoading = payload;
    },
    [SET_INSTITUTIONS_HISTORY_DATA_LOADING]: (state, payload) => {
        state.institutionHistoryDataLoading = payload;
    },
    [SET_MAP_INSTITUTIONS_LOADING]: (state, payload) => {
        state.mapInstitutionsLoading = payload;
    },
    [SET_MAP_INSTITUTIONS_BRANCH_LOADING]: (state, payload) => {
        state.mapInstitutionsBranchLoading = payload;
    },
    [SET_INSTITUTIONS_BRANCHES_LOADING]: (state, payload) => {
        state.institutionsBranchesLoading = payload;
    },
    [SET_INSTITUTION_LOADING]: (state, payload) => {
        state.institutionLoading = payload;
    },
    [SET_USER_HISTORIES_LOADING]: (state, payload) => {
        state.userHistoriesLoading = payload;
    },
    [GET_USER_HISTORIES_LOADING]: (state, payload) => {
        state.userHistoriesLoading = payload;
    },
    [SET_USER_ROLES_LOADING]: (state, payload) => {
        state.userRolesLoading = payload;
    },
    [SET_INSTITUTIONS]: (state, payload) => {
        state.institutions = payload;
    },
    [SET_HISTORY_INSTITUTIONS]: (state, payload) => {
        state.historyInstitutions = payload;
    },
    [SET_HISTORY_INSTITUTIONS_DATA]: (state, payload) => {
        state.historyInstitutionsData = payload;
    },
    [SET_INSTITUTIONS_BRANCHES]: (state, payload) => {
        state.institutionsBranches = payload;
    },
    [SET_MAP_INSTITUTIONS]: (state, payload) => {
        state.mapInstitutions = payload;
    },
    [SET_MAP_INSTITUTIONS_BRANCH]: (state, payload) => {
        state.mapInstitutionsBranch = payload;
    },
    [SET_USER_ROLES]: (state, payload) => {
        state.userRoles = payload;
    },
    [SET_SERVICE_TYPE]: (state, payload) => {
        state.serviceType = payload;
    },
    [SET_BRANCHES]: (state, payload) => {
        state.branches = payload;
    },
    [SET_SERVICES]: (state, payload) => {
        state.services = payload;
    },
    [SET_USER_HISTORIES]: (state, payload) => {
        state.userHistories = payload;
    },
    [SET_BRANCHES_DATA]: (state, payload) => {
        state.branchesData = payload;
    },
    [SET_BRANCHES_DATA_LOADING]: (state, payload) => {
        state.branchesDataLoading = payload;
    },
    [RESET_VALUES]: state => {
        state.success = null;
        state.error = null;
        state.loading = false;
    }
};

const actions = {
    [GET_SERVICES]: (context, payload) => {
        let url = SERVICES_URL;
        let filters = payload.filters;
        context.commit(SET_SERVICE_STATUS_LOADING, true);
        context.commit(SET_ERROR, null);
        if (filters) {
            url = `${url}?` + querystring.stringify(filters);
        }
        return ApiService.get(url)
            .then(response => {
                context.commit(SET_SERVICE_STATUS_LOADING, false);
                context.commit(SET_SERVICES, response.data);
            })
            .catch(error => {
                context.commit(SET_ERROR, error);
            });
    },
    [GET_SERVICE_TYPE]: async (context, payload) => {
        let url = SERVICE_TYPE_URL;
        let filters = payload.filters;
        context.commit(SET_SERVICE_TYPE_LOADING, true)
        context.commit(SET_ERROR, null)
        if (filters) {
            url = `${url}?` + querystring.stringify(filters);
        }
        return await ApiService.get(url)
            .then(response => {
                context.commit(SET_SERVICE_TYPE_LOADING, false);
                context.commit(SET_SERVICE_TYPE, response.data);
            })
            .catch(error => {
                context.commit(SET_ERROR, error);
            });
    },
    [GET_INSTITUTIONS]: (context, payload) => {
        let url = INSTITUTIONS_URL;
        let filters = payload.filters;
        context.commit(SET_INSTITUTION_LOADING, true);
        context.commit(SET_ERROR, null);
        if (filters) {
            url = `${url}?` + querystring.stringify(filters);
        }
        return ApiService.get(url)
            .then(response => {
                context.commit(SET_LOADING, false);
                context.commit(SET_INSTITUTION_LOADING, response.data);
            })
            .catch(error => {
                context.commit(SET_ERROR, error);
            });
    },
    [GET_HISTORY_INSTITUTIONS]: async (context, payload) => {
        let url = HISTORY_INSTITUTIONS_URL;
        let filters = payload.filters;
        context.commit(SET_INSTITUTIONS_HISTORY_LOADING, true);
        context.commit(SET_ERROR, null);
        if (filters) {
            url = `${url}?` + querystring.stringify(filters);
        }
        return await ApiService.get(url)
            .then(response => {
                context.commit(SET_INSTITUTIONS_HISTORY_LOADING, false);
                context.commit(SET_HISTORY_INSTITUTIONS, response.data);
            })
            .catch(error => {
                context.commit(SET_ERROR, error);
            });
    },
    [GET_HISTORY_INSTITUTIONS_DATA]: (context, payload) => {
        let url = HISTORY_INSTITUTIONS_DATA_URL;
        let filters = payload.filters;
        context.commit(SET_INSTITUTIONS_HISTORY_DATA_LOADING, true);
        context.commit(SET_ERROR, null);
        if (filters) {
            url = `${url}?` + querystring.stringify(filters);
        }
        return ApiService.get(url)
            .then(response => {
                context.commit(SET_INSTITUTIONS_HISTORY_DATA_LOADING, false);
                context.commit(SET_HISTORY_INSTITUTIONS_DATA, response.data);
            })
            .catch(error => {
                context.commit(SET_ERROR, error);
            });
    },
    [GET_BRANCHES]: (context, payload) => {
        let url = BRANCHES_URL;
        let filters = payload.filters;
        context.commit(SET_LOADING, true);
        context.commit(SET_ERROR, null);
        if (filters) {
            url = `${url}?` + querystring.stringify(filters);
        }
        return ApiService.get(url)
            .then(response => {
                context.commit(SET_LOADING, false);
                context.commit(SET_BRANCHES, response.data);
            })
            .catch(error => {
                context.commit(SET_ERROR, error);
            });
    },
    [GET_INSTITUTIONS_BRANCHES]: (context, payload) => {
        let url = INSTITUTIONS_BRANCHES_URL;
        let filters = payload.filters;
        context.commit(SET_INSTITUTIONS_BRANCHES_LOADING, true);
        context.commit(SET_ERROR, null);
        if (filters) {
            url = `${url}?` + querystring.stringify(filters);
        }
        return ApiService.get(url)
            .then(response => {
                context.commit(SET_INSTITUTIONS_BRANCHES_LOADING, false);
                context.commit(SET_INSTITUTIONS_BRANCHES, response.data);
            })
            .catch(error => {
                context.commit(SET_ERROR, error);
            });
    },
    [GET_MAP_INSTITUTIONS]: (context, payload) => {
        let url = MAP_INSTITUTIONS_URL;
        let filters = payload.filters;
        context.commit(SET_MAP_INSTITUTIONS_LOADING, true);
        context.commit(SET_ERROR, null);
        if (filters) {
            url = `${url}?` + querystring.stringify(filters);
        }
        return ApiService.get(url)
            .then(response => {
                context.commit(SET_MAP_INSTITUTIONS_LOADING, false);
                context.commit(SET_MAP_INSTITUTIONS, response.data);
            })
            .catch(error => {
                context.commit(SET_ERROR, error);
            });
    },
    [GET_MAP_INSTITUTIONS_BRANCH]: (context, payload) => {
        let url = MAP_INSTITUTIONS_BRANCH_URL;
        let filters = payload.filters;
        context.commit(SET_MAP_INSTITUTIONS_BRANCH_LOADING, true);
        context.commit(SET_ERROR, null);
        if (filters) {
            url = `${url}?` + querystring.stringify(filters);
        }
        return ApiService.get(url)
            .then(response => {
                context.commit(SET_MAP_INSTITUTIONS_BRANCH_LOADING, false);
                context.commit(SET_MAP_INSTITUTIONS_BRANCH, response.data);
            })
            .catch(error => {
                context.commit(SET_ERROR, error);
            });
    },
    [GET_USER_ROLES]: async(context, payload) => {
        let url = USER_ROLES_URL;
        let filters = payload.filters;
        context.commit(SET_USER_ROLES_LOADING, true);
        context.commit(SET_ERROR, null);
        if (filters) {
            url = `${url}?` + querystring.stringify(filters);
        }
        return await ApiService.get(url)
            .then(response => {
                context.commit(SET_USER_ROLES_LOADING, false);
                context.commit(SET_USER_ROLES, response.data);
            })
            .catch(error => {
                context.commit(SET_ERROR, error);
            });
    },
    [GET_USER_HISTORIES]: (context, payload) => {
        let url = USER_HISTORIES_URL;
        let filters = payload.filters;
        context.commit(SET_USER_HISTORIES_LOADING, true);
        context.commit(SET_ERROR, null);
        if (filters) {
            url = `${url}?` + querystring.stringify(filters);
        }
        return ApiService.get(url)
            .then(response => {
                context.commit(SET_USER_HISTORIES_LOADING, false);
                context.commit(SET_USER_HISTORIES, response.data);
            })
            .catch(error => {
                context.commit(SET_ERROR, error);
            });
    },
    [GET_BRANCHES_DATA]: (context, payload) => {
        let url = BRANCH_DATA_URL;
        let filters = payload.filters;
        context.commit(SET_BRANCHES_DATA_LOADING, true);
        context.commit(SET_ERROR, null);
        if (filters) {
            url = `${url}?` + querystring.stringify(filters);
        }
        return ApiService.get(url)
            .then(response => {
                context.commit(SET_BRANCHES_DATA_LOADING, false);
                context.commit(SET_BRANCHES_DATA, response.data);
            })
            .catch(error => {
                context.commit(SET_ERROR, error);
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
